import { createReducer } from 'typesafe-actions'
import CarlineData from '../../entities/CarlineData'
import { setCarlineDataState } from '../actions/app/carlineData.actions'

export type CarlineDataState = CarlineData

export const defaultState: CarlineDataState = {
    carlineGroups: [],
}

const carlineDataReducer = createReducer(defaultState)
    .handleAction(setCarlineDataState, (state, action) => action.payload)

export default carlineDataReducer
